<template>
    <div>
        <div :class="`input-checkbox-multi-scroll ${disabled?'input-checkbox-multi-disabled':''}`">
            <div v-for="(value, index) in items" class="input-checkbox-multi-item">
                <input 
                    type="checkbox" 
                    :disabled="disabled"
                    :value="value" 
                    :id="`${name}-${index}`" 
                    :checked="hasValue(value)" 
                    @input="changeRange(index, $event.target )"
                />
                <label :for="`${name}-${index}`">{{ value }}</label>
            </div>
        </div>

        <div v-if="error"  class="el-form-item__error">{{ error }}</div>
    </div>
</template>

<script>

export default {
    name: "CheckboxMulti",
    data(){
        return {
            name:'',
            values: [],
        }
    },
    mixins: [],
    props: {
        items: [],
        disabled: false,
        error:'',
        modelValue: [],
        placeholder: {
            type: String,
            default: '項目グループ名（中）',
        },
    },

    created() {
        this.name = (Math.random() + 1).toString(36).substring(10)
        
        if( this.$attrs.value === null || typeof this.$attrs.value === 'undefined'){
            this.values = []
        } else  if( this.$attrs.value.includes('{') ){
            this.values = Object.values(JSON.parse(this.$attrs.value))
        } else {
            this.values = this.$attrs.value.split(",").map(function(value){
                return value.trim()
            }).filter(function(value){ 
                return value.length > 0 
            })
        }
        
        if( this.values.length > 0 && this.values[0].includes('{') ){
            console.warn("data has error");
            this.values = []
        } else {
            this.$emit('input', this.values.join(','))
        }
    },

    methods: {
        handleInput(value) {
            this.$emit('blur', value)
        },

        hasValue(value){
            if( !this.values || this.values.length < 1 || this.disabled){
                return false
            }
            const test = this.values.indexOf(value)
            return this.values.indexOf(value) > -1
        },

        changeRange(i, elm) {
            if( !elm || elm.type !== "checkbox"){
                return
            }
            const inputValue = elm.value

            if( elm.checked === true ){
                this.values.push(inputValue)
            } else {
                const index = this.values.indexOf(inputValue);
                if (index > -1) {
                    this.values.splice(index, 1);
                }
            }
            this.$emit('input', this.values.join(','))
        },
    },

}
</script>

<style lang="scss" scoped>
.el-form-item__error {
    margin-left: 22px;
    margin-top: 10px;  
}
.input-checkbox-multi-scroll {
    min-height: 10rem;
    max-height: 10rem;
    min-width: 350px;
    max-width: 550px;
    margin-left: 22px;
    overflow-y: scroll;
    border: 1px solid #DCDFE6;
    border-radius: 4px;

    .input-checkbox-multi-item {
        height: 25px;
        line-height: 25px;
        margin-left: 0.5rem;

        label {
            cursor: pointer;
            display: block;
            line-height: 25px;
            margin-bottom: 0;
            margin-left: 1rem;
            position: relative;
            top: -25px;
            left: 5px;

            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* number of lines to show */
                    line-clamp: 1; 
            -webkit-box-orient: vertical;
            
        }

        input[type=checkbox] {
            position: relative;
            top: 1px;
            cursor: pointer;

            &:checked+label {
                color: #409EFF;
            }
        }
    }

    &.input-checkbox-multi-disabled {
        border-color: #C0C4CC;
        label {
            color: #C0C4CC;
        }
    }
}
@media only screen and (max-width: 992px) {
    .input-checkbox-multi-scroll {
    margin-left: 10px;
  }
}

</style>